// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1Pepu","disabled":"FileBtn_disabled__2tkIg","warn":"FileBtn_warn__1fXNk","fade":"FileBtn_fade__2OHeD"};